export type SingleFlightWakeOptions = {
  onCoalesced?: () => void;
};

export function createSingleFlightWake<T>(
  run: () => Promise<T>,
  options: SingleFlightWakeOptions = {},
): () => Promise<T> {
  let running: Promise<T> | null = null;
  let trailingWakeRequested = false;

  async function runLoop(): Promise<T> {
    let lastResult: T;
    for (;;) {
      trailingWakeRequested = false;
      lastResult = await run();
      if (!trailingWakeRequested) return lastResult;
    }
  }

  return () => {
    if (running) {
      trailingWakeRequested = true;
      options.onCoalesced?.();
      return running;
    }

    running = runLoop().finally(() => {
      running = null;
      trailingWakeRequested = false;
    });
    return running;
  };
}
